import React from 'react';
import { Content } from './shared';

const BcbsLasik = () => (
  <Content>
    Imagine your world without glasses. Enjoy huge discounts on LASIK at LasikPlus locations.
    <ol>
      <li>Visit the Blue365 website and register.</li>

      <li>
        Go to Hearing & Vision {'>'} LasikPlus {'>'} Go to partner site.
      </li>
    </ol>
  </Content>
);

export default BcbsLasik;
